<template>
  <div class="tooltip-b tl small member"
    v-if="userInfo != null"
  >
    <ul class="">
      <li>
        <div class="row1">
          <div class="avatar">
            <img v-if="userPhoto != null" :src="userPhoto" alt="" />
            <img v-else src="@/assets/img/no-avatar.png" alt="" />
          </div>
          <!-- 협력업체 유저 -->
          <div class="name" v-if="isExternalUser == 'Y'">{{ userInfo.userName }} <span>{{$i18nUtil.trans("message.MultiOrg.003","협력업체")}}</span></div>
          <!-- 임직원, 그룹사 -->
          <div class="name" v-else>{{ userInfo.userName }} <span>{{ userInfo.jobPositionName }}</span></div>
          
          <!-- 협력업체 유저 -->
          <div class="co" v-if="isExternalUser == 'Y'">{{ userInfo.partnerName }}</div>
          <!-- 임직원, 그룹사 -->
          <div class="co" v-else>{{ userInfo.companyName + ' / ' + userInfo.deptName }}</div>
          
          <div class="mail ell-singleline">{{ userInfo.email }}</div>
          <div class="tel">{{ userInfo.cellPhoneNo }}</div>
          <!-- 링크 기능 추가시 사용 S -->
          <!-- <a :href="'mailto:' + userInfo.email" class="mail ell-singleline" v-if="show">{{ userInfo.email }}</a> -->
          <!-- <a :href="'tel:' + userInfo.cellPhoneNo" class="tel" v-if="show">{{ userInfo.cellPhoneNo }}</a> -->
          <!-- 링크 기능 추가시 사용 E -->
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from "vuex";
export default {
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false,
      userInfo: null,
      userPhoto: null,
      isExternalUser: "N",
    }
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    ...mapActions("coworkUtils", ["HW_GET_USER_PHOTO"]),
    getUserInfo() {
      let obj = this;
      let url = "/api/org/getUserInfo";
      let param = {
        userId: obj.userId
      }

      axios
        .post(url, param)
        .then(res => {
          if(res.data.errorCode != null) {
            return;
          }
          obj.isExternalUser = res.data.result.isExternalUser;
          let userInfo = res.data.result.userInfo
          if(obj.$i18nUtil.getLanguage() === 'ko') {

          }else{
            // locale: en 일 때, 사용자 정보 영문 컬럼으로 대체
            userInfo.userName = userInfo.userNameEn != null ? userInfo.userNameEn : userInfo.userName;
            userInfo.deptName = userInfo.deptNameEn != null ? userInfo.deptNameEn : userInfo.deptName;
            userInfo.companyName = userInfo.companyNameEn != null ? userInfo.companyNameEn : userInfo.companyName;
            userInfo.jobPositionName = userInfo.jobPositionNameEn != null ? userInfo.jobPositionNameEn : userInfo.jobPositionName;
            userInfo.jobFunctionName = userInfo.jobFunctionNameEn != null ? userInfo.jobFunctionNameEn : userInfo.jobFunctionName;
          }
          obj.userInfo = userInfo;
          
          obj.HW_GET_USER_PHOTO({userId: obj.userId, callback(blob) { obj.userPhoto = blob; }});
        })
        .catch(err => {
          console.log("axios err => ", err);
        });
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/common/user/UserTooltip.vue